import { Navigate, Route, Routes } from 'react-router-dom';

import OperationDashboard from 'src/features/payment/components/OperationDashboard';
import PaymentLayout from 'src/features/payment/components/PaymentLayout';
import PayStationDashboard from 'src/features/payment/components/PayStationDashboard';
import OperationsTable from 'src/features/payment/components/tables/OperationsTable';
import PaymentsTable from 'src/features/payment/components/tables/PaymentsTable';
import PayStationEventsTable from 'src/features/payment/components/tables/PayStationEventsTable';
import PayStationsTable from 'src/features/payment/components/tables/PayStationsTable';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { PERMISSION } from 'src/features/auth';
import { PATH } from 'src/features/navigation/utils/constants';

export default function PaymentRoutes() {
    const accessPayments = useHasPermissions([PERMISSION.ACCESS_PAYMENTS]);
    const accessPayStations = useHasPermissions([PERMISSION.ACCESS_PAY_STATIONS]);
    const accessPayStationsOperations = useHasPermissions([PERMISSION.ACCESS_PAY_STATION_OPERATIONS]);
    const accessPayStationsEvents = useHasPermissions([PERMISSION.ACCESS_PAY_STATION_EVENTS]);

    const defaultRoutePath = (() => {
        if (accessPayments) return `/${PATH.PAYMENTS}/payments`;
        if (accessPayStations) return `/${PATH.PAYMENTS}/pay-station`;
        if (accessPayStationsOperations) return `/${PATH.PAYMENTS}/operation`;
        if (accessPayStationsEvents) return `/${PATH.PAYMENTS}/event`;

        return '/no-access';
    })();
    return (
        <Routes>
            <Route path="" element={<PaymentLayout />}>
                <Route index element={<Navigate to={defaultRoutePath} replace />} />
                {accessPayments && (
                    <Route path="payments" element={<PaymentsTable hasExtraColumns enableSearchParams />} />
                )}
                {accessPayStations && <Route path="pay-station" element={<PayStationsTable />} />}
                {accessPayStationsOperations && (
                    <Route path="operation" element={<OperationsTable enableSearchParams />} />
                )}
                {accessPayStationsEvents && (
                    <Route path="event" element={<PayStationEventsTable enableSearchParams />} />
                )}
            </Route>
            {accessPayStations && <Route path="pay-station/:payStationId" element={<PayStationDashboard />} />}
            {accessPayStationsOperations && (
                <Route path="operation/:operationId" element={<OperationDashboard />} />
            )}
            <Route path="*" element={<Navigate to=".." />} />
        </Routes>
    );
}
